(() => {
  if (window.loncryMobileHeaderReady) return;
  const header = document.querySelector('.loncry-sticky-site-header');
  if (!header) return;
  window.loncryMobileHeaderReady = true;
  let frame;
  const sync = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const height = Math.ceil(header.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty('--loncry-mobile-header-height', height + 'px');
    });
  };
  sync();
  window.addEventListener('pageshow', sync);
  window.addEventListener('resize', sync, { passive: true });
  window.addEventListener('load', sync, { once: true });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', sync, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(sync).observe(header);
})();
